const ITEMS = [
  "LEEDS BRADFORD (LBA)",
  "MANCHESTER (MAN)",
  "EAST MIDLANDS (EMA)",
  "NEWCASTLE (NCL)",
  "ZERO SURCHARGES ON DELAYS",
  "LICENSED EXECUTIVE FLEET",
  "FLIGHT TRACKING INCLUDED",
];

export const Marquee = () => (
  <div className="overflow-hidden border-b border-white/10 bg-[#0e1626] py-3.5" data-testid="airports-marquee">
    <div className="mq-track font-mono-lbl text-xs uppercase tracking-[0.2em] text-slate-300">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center gap-12 pr-12" aria-hidden={copy === 1}>
          {ITEMS.map((t) => (
            <span key={t}>&bull; {t}</span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
